import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss']
})
export class BulletinComponent implements OnInit {
  bulletin: string = '';
  // sub:Subscription;
  // constructor(private bulletinService:BulletinService) { }

  ngOnInit(): void {
    // this.sub=this.bulletinService.changeBulletin.subscribe(
    //   res=>{
    //     document.querySelector('.bulletinMarque').innerHTML=res;
    //   }
    // );
  }
  // ngOnDestroy(): void {
  //   this.sub.unsubscribe();
  // }
}
